import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  checkAppDeploymentVersion,
  recoverAppDeploymentPreloadError,
} from '../_services/appDeploymentRefresh.services.js';
import { GAME_PLAYER_ACTIVITY_EVENT, isAnyGameActive } from '../lib/gameLaunch';

const useAppDeploymentRefresh = () => {
  const location = useLocation();
  const firstCheckRef = useRef(true);
  const gameWasActiveRef = useRef(isAnyGameActive());

  useEffect(() => {
    const force = firstCheckRef.current;
    firstCheckRef.current = false;
    void checkAppDeploymentVersion({ force });
  }, [location.key, location.pathname, location.search]);

  useEffect(() => {
    const checkCurrentVersion = () => { void checkAppDeploymentVersion(); };
    const checkWhenVisible = () => {
      if (document.visibilityState === 'visible') checkCurrentVersion();
    };
    const handlePreloadError = (event) => {
      event?.preventDefault?.();
      recoverAppDeploymentPreloadError();
    };
    const checkAfterGame = () => {
      const active = isAnyGameActive();
      if (gameWasActiveRef.current && !active) queueMicrotask(() => {
        if (!isAnyGameActive()) void checkAppDeploymentVersion({ force: true });
      });
      gameWasActiveRef.current = active;
    };
    window.addEventListener('focus', checkCurrentVersion);
    window.addEventListener('online', checkCurrentVersion);
    window.addEventListener('vite:preloadError', handlePreloadError);
    window.addEventListener(GAME_PLAYER_ACTIVITY_EVENT, checkAfterGame);
    document.addEventListener('visibilitychange', checkWhenVisible);
    return () => {
      window.removeEventListener('focus', checkCurrentVersion);
      window.removeEventListener('online', checkCurrentVersion);
      window.removeEventListener('vite:preloadError', handlePreloadError);
      window.removeEventListener(GAME_PLAYER_ACTIVITY_EVENT, checkAfterGame);
      document.removeEventListener('visibilitychange', checkWhenVisible);
    };
  }, []);
};

export default useAppDeploymentRefresh;
